import { useEffect, useRef, useState } from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Menu,
  MenuItem,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import styles from "./styles.module.css";
import WhiteButton from "../../../components/WhiteButton";
import { formatValue } from "../../../utils/formatValue";
import PreviewIcon from "@mui/icons-material/Preview";
import generatePDF from "react-to-pdf";
import BlueButton from "../../../components/BlueButton";
import logo from "../../../images/fenix_azul.png";
import extractExcelFunction from "./ExtractExcelFunction";

const BtnExtratorRelatorio = ({ data, fileName = "relatório" }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [somaEmpresas, setSomaEmpresas] = useState({ total: "", unitario: [] });
  const [openPreview, setOpenPreview] = useState(false);
  const formRef = useRef();

  const cleanData = (value) => {
    return parseFloat(
      value.replace("R$ ", "").replace(/\./g, "").replace(",", ".")
    );
  };

  const handleOptions = (event) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handlePreview = () => {
    setOpenPreview(!openPreview);
  };

  const handleCalculaEmpresasUnitaria = (lista) => {
    const resultado = Object.values(
      lista.reduce((acc, curr) => {
        if (!acc[curr.cnpj]) {
          acc[curr.cnpj] = {
            ...curr,
            valorFatura: curr.vlFatura,
            valorFinalHonorario: curr.vlFinalHonorario,
          };
        } else {
          acc[curr.cnpj].vlFatura += curr.vlFatura;
          acc[curr.cnpj].vlFinalHonorario += curr.vlFinalHonorario;
        }
        return acc;
      }, {})
    ).map((item) => ({
      cnpj: item.cnpj,
      idEmpresa: item.idEmpresa,
      razaoSocial: item.razaoSocial,
      valorFatura: `R$${formatValue("number", item.valorFatura)}`,
      valorFinalHonorario: `R$${formatValue(
        "number",
        item.valorFinalHonorario
      )}`,
    }));

    return resultado;
  };

  const handleCalculaEmpresasTotal = (lista) => {
    const total = lista.reduce((acc, curr) => {
      const valorNumerico = parseFloat(
        curr.vlFatura.replace("R$ ", "").replace(/\./g, "").replace(",", ".")
      );
      return acc + valorNumerico;
    }, 0);

    return `R$ ${formatValue("number", total)}`;
  };

  useEffect(() => {
    const limpaMonetario = data.map((item) => ({
      ...item,
      vlFatura: cleanData(item.vlFatura),
      vlFinalHonorario: cleanData(item.vlFinalHonorario),
      vlIr: cleanData(item.vlIr),
      PisCofins: cleanData(item.PisCofins),
      valorCsll: cleanData(item.valorCsll),
      Boleto: cleanData(item.Boleto),
    }));

    setSomaEmpresas({
      unitario: handleCalculaEmpresasUnitaria(limpaMonetario),
      total: handleCalculaEmpresasTotal(data),
    });
  }, [data]);

  const cnpjs = somaEmpresas.unitario.map((item) => {
    return item.cnpj;
  });

  const tableView = cnpjs.map((cnpj) => {
    const listaAtual = data.filter((itemAtual) => itemAtual.cnpj === cnpj);
    const valoresAtuais = somaEmpresas.unitario.filter(
      (empresa) => empresa.cnpj === cnpj
    );
    console.log(valoresAtuais);
    return (
      <>
        <div key={cnpj} style={{ marginBottom: "1.5rem" }}>
          <h4>{`${valoresAtuais[0].cnpj} - ${valoresAtuais[0].razaoSocial}`}</h4>
          <table className={styles.pdfTable}>
            <thead className={styles.pdfTHead}>
              <tr>
                <th>Serviço</th>
                <th>Dt. Fatura</th>
                <th>% Honorários</th>
                <th>Imposto</th>
                <th>Vl. Fatura</th>
                <th>Vl. Final Honorário</th>
                <th>Vl. IR</th>
                <th>Vl. PIS/ Cofins</th>
                <th>Vl. Csll</th>
                <th>Boleto</th>
                <th>Histórico Fatura</th>
              </tr>
            </thead>
            <tbody>
              {listaAtual.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className={styles.line__td}>{item["servico"]}</td>
                    <td className={styles.line__td}>{item["dtFatura"]}</td>
                    <td
                      className={styles.line__td}
                      style={{ textAlign: "right" }}
                    >
                      {item["percentualHonorarios"]}
                    </td>
                    <td
                      className={styles.line__td}
                      style={{ textAlign: "right" }}
                    >
                      {item["imposto"]}
                    </td>
                    <td
                      className={styles.line__td}
                      style={{ textAlign: "right" }}
                    >
                      {item["vlFatura"]}
                    </td>
                    <td
                      className={styles.line__td}
                      style={{ textAlign: "right" }}
                    >
                      {item["vlFinalHonorario"]}
                    </td>
                    <td
                      className={styles.line__td}
                      style={{ textAlign: "right" }}
                    >
                      {item["vlIr"]}
                    </td>
                    <td
                      className={styles.line__td}
                      style={{ textAlign: "right" }}
                    >
                      {item["PisCofins"]}
                    </td>
                    <td
                      className={styles.line__td}
                      style={{ textAlign: "right" }}
                    >
                      {item["valorCsll"]}
                    </td>
                    <td
                      className={styles.line__td}
                      style={{ textAlign: "right" }}
                    >
                      {item["vlFatura"]}
                    </td>
                    <td className={styles.line__td}>
                      {item["historicoFatura"]}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <h4>{`Valor Compensado: ${valoresAtuais[0].valorFatura}`}</h4>
            <h4>{`Valor Empresa Honorário: ${valoresAtuais[0].valorFinalHonorario}`}</h4>
            <hr />
          </div>
        </div>
      </>
    );
  });

  const handleExcel = () => {
    return extractExcelFunction(data, fileName);
  };

  const handleDownloadDoc = (type) => {
    switch (type) {
      case "PDF":
        handlePreview();
        break;

      case "excel":
        handleExcel();
        break;

      default:
        console.log(type);

        break;
    }
  };

  const styleMenuItem = {
    display: "flex",
    gap: "5px",
    cursor: "pointer",
  };

  const styleText = {
    color: "#18316e",
  };

  const btnStyle = {
    color: "#fff",
    backgroundColor: "#18316e",
    borderRadius: "8px",
    "&:hover": { backgroundColor: "#1976d2" },
  };

  const getTargetElement = () => formRef.current;

  const handleExportPDF = async () => {
    const options = {
      filename: `Resumo_${fileName}.pdf`,
      page: {
        margin: 5,
      },
    };
    generatePDF(getTargetElement, options);
  };

  return (
    <>
      <Button
        startIcon={<DescriptionIcon />}
        sx={btnStyle}
        onClick={handleOptions}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        EXTRAIR RELATÓRIO
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleOptions}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => handleDownloadDoc("PDF")} sx={styleMenuItem}>
          <PictureAsPdfIcon sx={styleText} />
          <span style={styleText}>PDF</span>
        </MenuItem>
        <MenuItem onClick={() => handleDownloadDoc("excel")} sx={styleMenuItem}>
          <TableChartOutlinedIcon sx={styleText} />
          <span style={styleText}>Excel</span>
        </MenuItem>
      </Menu>

      <Dialog
        fullWidth
        maxWidth="xl"
        open={openPreview}
        onClose={handlePreview}
      >
        <DialogTitle>
          <div className={styles.title__header}>
            <PreviewIcon fontSize="large" sx={{ color: "#18316e" }} />
            <h2>Prévia de relatório em PDF</h2>
          </div>
        </DialogTitle>
        <DialogContent>
          <div ref={formRef}>
            <header className={styles.title__pdf}>
              <h2>Faturamento</h2>
              <img
                src={logo}
                alt="Logo azul da taxation mind"
                className={styles.logo__pdf}
              />
            </header>

            {tableView}
            <h3>Valor Compensado Total: {somaEmpresas?.total}</h3>
          </div>
        </DialogContent>
        <DialogActions>
          <div className={styles.btn__dialogPreview}>
            <WhiteButton clickFunction={handlePreview} textValue="Cancelar" />
            <BlueButton
              clickFunction={handleExportPDF}
              textValue="Exportar"
              contentIcon={<PictureAsPdfIcon />}
            />
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BtnExtratorRelatorio;
